import { VendorStockPage } from "@/features/vendor-app/pages/VendorStockPage";
import { createFileRoute } from "@tanstack/react-router";

export type VendorStockSearch = {
	branchID?: string;
	productID?: string;
};

const str = (v: unknown): string | undefined =>
	typeof v === "string" && v !== "" ? v : undefined;

export const Route = createFileRoute("/vendor/stock/")({
	// Filters live in the URL so they survive navigating to a product's
	// detail / per-cabang view and back.
	validateSearch: (search: Record<string, unknown>): VendorStockSearch => ({
		branchID: str(search.branchID),
		productID: str(search.productID),
	}),
	component: VendorStockPage,
});
